<template>
  <div>
    <v-text-field
      v-model="search"
      class="search-input"
      label="Поиск"
      single-line
      color="accent"
      hide-details
      @keypress.enter="searchRound"
    >
      <template #append-outer>
        <v-icon class="icon" style="font-size: 18px" @click="searchRound">fas fa-check</v-icon>
        <v-icon class="icon" @click="cancelSearch">fas fa-times</v-icon>
      </template>
    </v-text-field>
    <paginated-table
      :items="searchRounds.length === 0 ? items : searchRounds"
      :headers="headers"
      :loading="loading"
      :pullFunction="pull"
    >
      <template #items="props">
        <GameStatisticsItem :item="props.item" />
      </template>
    </paginated-table>
  </div>
</template>

<script>
import GameStatisticsItem from './CrashStatisticsItem'
import { getStatisticsRounds } from '../../../../../api/wheel'
import PaginatedTable from '../../../PaginatedTable'
import { getCrashRoundsStats } from '../../../../../api/crash'

export default {
  name: 'CrashStatisticsTable',
  components: { PaginatedTable, GameStatisticsItem },
  props: {
    items: Array,
    pullFunction: Function
  },
  data () {
    return {
      searchRounds: [],
      search: '',
      loading: false,
      pagination: {
        sortBy: 'created_at',
        descending: true
      },
      headers: [
        { text: 'id Раунда', value: 'id' },
        { text: 'Дата и время', value: 'created_at' },
        { text: 'Кол-во игроков', value: 'count_player' },
        { text: 'Сумма ставок', value: 'bets_sum' },
        { text: 'Сумма выигрыша', value: 'prizes_sum' },
        { text: 'Результат', value: 'result' },
        { text: 'Итог для казино', value: 'total' }
      ]
    }
  },
  watch: {
    pagination () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  methods: {
    searchRound () {
      getCrashRoundsStats({
        limit: 25, offset: 0, round_id: +this.search
      }).then(response => {
        this.searchRounds = response.data
        if (this.searchRounds.length === 0)
          this.$store.dispatch('showErrorMessage', 'Раунд не найден')
      })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('showErrorMessage', 'Ошибка')
        })
    },
    cancelSearch () {
      this.search = ''
      this.searchRounds = []
    },
    async pull (page) {
      this.loading = true
      await this.pullFunction(page)
      this.loading = false
    }
  }
}
</script>

<style scoped>
    .icon {
        cursor: pointer;
        font-size: 20px;
        padding: 2px 4px;
    }

    .icon:hover {
        background: #eeeef4;
        border-radius: 4px;
    }

    .search-input {
        flex: none;
        width: 30%;
        margin-left: auto;
        margin-bottom: 10px;
    }
</style>
